import i18next from "i18next"
import { Alert, Col, Form, Row } from "react-bootstrap"
// @ts-ignore
import 'react-quill/dist/quill.snow.css';
import ReactQuill from "react-quill"
import CreatableSelect from "react-select/creatable"
import Select from "react-select"
import MultiFileUploader from "src/components/MultiFileUploader/MultiFileUploader"
import { emailIsValid, removeDuplicates } from "src/utils"
import { OPPORTUNITY_SUPPORTED_FILE_TYPES } from "src/utils/constants"

export function SendDocumentsPanel({ funnelData, sendData, mustComplete, setDealerFolderData, setSendData, documentationFolder, loadDealerDocs, dealerFolderData, sendFiles, setSendFiles }) {
  return (
    <>
      <div>
        {!funnelData.account ? (
          <Alert>
            {i18next.t('account_selection_required_to_proceed')}
          </Alert>
        ) : (
          <div>
            <Row className='my-2'>
              <Col>
                <Form.Group>
                  <Form.Check
                    type="switch"
                    name='send-docs-switch'
                    label={i18next.t('send_documents_to_customer_for_signature')}
                    checked={sendData.enabled}
                    disabled={mustComplete.includes('send_docs')}
                    onChange={({ target }) => {
                      const enabled = target.checked
                      if (!target.checked) {
                        setDealerFolderData([])
                        setSendData({ ...sendData, dealer: null, dealerDocs: [], enabled })
                      } else {
                        setSendData({ ...sendData, enabled })
                      }
                    }}
                  />
                </Form.Group>
              </Col>
            </Row>

            {sendData.enabled && (
              <div className='mt-4'>
                <Row>
                  <Col md={4}>
                    <Select
                      menuPosition="fixed"
                      options={documentationFolder}
                      placeholder={i18next.t('select_rental_company')}
                      noOptionsMessage={() => `${i18next.t('loading')}...`}
                      value={sendData.dealer}
                      onChange={(opt: any) => {
                        loadDealerDocs(opt)
                      }}
                    />
                    {/* Dealer docs checkbox */}
                    {dealerFolderData.length > 0 && (
                      <div className='mt-3'>
                        {dealerFolderData.map(el => {
                          return (
                            <Form.Check
                              key={el.id}
                              label={el.title}
                              name="dealer-docs"
                              type={'checkbox'}
                              value={el.title}
                              checked={sendData.dealerDocs.includes(el.title)}
                              onChange={({ target: { checked, value } }) => {
                                const docs = new Set(sendData.dealerDocs);
                                checked ? docs.add(value) : docs.delete(value)

                                setSendData({ ...sendData, dealerDocs: Array.from(docs) })
                              }}
                            />
                          )
                        })}
                      </div>
                    )}
                  </Col>
                </Row>

                <div className="my-4"><hr /></div>

                <Row >
                  <Col md={6}>
                    <CreatableSelect
                      isClearable
                      components={{ DropdownIndicator: null }}
                      placeholder="A"
                      options={sendData.to ? [sendData.to] : []}
                      noOptionsMessage={() => i18next.t('add_customer_email')}
                      value={sendData.to}
                      formatCreateLabel={(i) => emailIsValid(i) ? `Invia a ${i}` : `${i}`}
                      onChange={(opt: any) => {
                        if (!opt) setSendData({ ...sendData, to: opt })
                        else if (emailIsValid(opt.value)) {
                          setSendData({ ...sendData, to: opt })
                        }
                      }}
                    ></CreatableSelect>
                  </Col>
                  <Col md={6}>
                    <CreatableSelect
                      isMulti
                      components={{ DropdownIndicator: null }}
                      placeholder="C.c."
                      noOptionsMessage={() => i18next.t('add_cc_recipients')}
                      value={sendData.cc}
                      formatCreateLabel={(i) => emailIsValid(i) ? `Aggiungi ${i}` : `${i}`}
                      onChange={(opt: any) => {
                        opt = opt.filter(el => emailIsValid(el.value))
                        setSendData({ ...sendData, cc: removeDuplicates(opt) })
                      }}
                    ></CreatableSelect>
                  </Col>
                </Row>
                <Row className='mt-2'>
                  <Col xs={12}>
                    <ReactQuill theme="snow"
                      placeholder={i18next.t('write_email')}
                      value={sendData.message} onChange={(message) => {
                        setSendData({ ...sendData, message: message })
                      }} />
                  </Col>
                </Row>
                <div className="mt-4">
                  <MultiFileUploader
                    files={sendFiles}
                    setFiles={setSendFiles}
                    types={OPPORTUNITY_SUPPORTED_FILE_TYPES}
                  ></MultiFileUploader>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </>
  )
}
